import { Breakpoint } from '../enums/breakpoint';

export const breakpoints = {
  [Breakpoint.Large]: 1200,
  [Breakpoint.Medium]: 940,
  [Breakpoint.Small]: 480,
  [Breakpoint.XLarge]: 1440,
};
